import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import TooltipIcon from 'modules/shift_management/components/ShiftManagement//TooltipIcon'
import AddEmployeesNoticeBox from 'modules/shift_management/components/ShiftManagement/AddEmployeesNoticeBox'
import ApplyShiftTemplateForm from 'modules/shift_management/lib/forms/ApplyShiftTemplateForm'
import CommonSelectorsForm from 'modules/shift_management/lib/forms/CommonSelectorsForm'

interface Props {
  form: CommonSelectorsForm | ApplyShiftTemplateForm
  selectableEmployeeIds: number[]
}

const AssigneesSelector = ({ form, selectableEmployeeIds }: Props) => {
  const errors = form.get('employee_id')?.errors ?? []
  const error = errors[0] ?? undefined

  return (
    <>
      <Box
        className={error && 'error-anchor'}
        flexDirection="row"
        gap="s16"
        justifyContent="center"
        alignItems="center"
      >
        <Box flexNoShrink>
          <TooltipIcon.Medium
            icon="person"
            label={i18n.t('shift_management.actions_sidepanel.tooltip.assignee')}
            color="grey700"
          />
        </Box>

        {/* Send error once we migrate to the new EmployeeSelector using GraphQL */}
        <Box width="full" flexGrow>
          <EmployeeSelectorV2
            error={error}
            multiple
            forcedFilters={{
              employeeIds: selectableEmployeeIds,
            }}
            messages={{
              placeholder: i18n.t('employees.select_employee.other'),
            }}
            onChange={(value) => {
              if (!value) return
              form.employeeSelection = value
            }}
            value={form.employeeSelection?.ids ?? undefined}
            options={{
              hideLabel: true,
            }}
          />
        </Box>
      </Box>
      <AddEmployeesNoticeBox newVersion />
    </>
  )
}

export default observer(AssigneesSelector)
